import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const addCaregiverReducer = (state = initialState, action) => {
  return state;
};

const addCaregiver = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/user/invite`, formData)
    .then(({ data }) => {
      return Promise.resolve({
        message: "Caregiver created successfully",
        caregiver: { userId: data?.id, ugnxId: data?.ugnxId },
      });
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default:
          error.response?.data ||
          "There was an error while trying to add a caregiver",
      });
    });
};

export const mapDispatchToProps = {
  addCaregiver,
};
